import { Col, Form } from "react-bootstrap";
import { FieldError, RegisterOptions, UseFormRegister } from "react-hook-form";
import styleUtils from "../../styles/utils.module.scss";

interface TextInputFieldInlineProps {
  name: string;
  label: string;
  register: UseFormRegister<any>;
  registerOptions?: RegisterOptions;
  error?: FieldError;
  [x: string]: any;
}

const TextInputFieldInline = ({
  name,
  label,
  register,
  registerOptions,
  error,
  ...props
}: TextInputFieldInlineProps) => {
  return (
    <Form.Group className="mb-3" controlId={name + "-input"}>
      <Form.Label
        column
        sm={2}
        className={"lightText"}>{`${label}:`}</Form.Label>
      <Col sm={10}>
        <Form.Control
          {...props}
          {...register(name, registerOptions)}
          isInvalid={!!error}
        />
        <Form.Control.Feedback type="invalid">
          {error?.message}
        </Form.Control.Feedback>
      </Col>
    </Form.Group>
  );
};

export default TextInputFieldInline;
